import React from 'react';
import PropTypes from 'prop-types';

const ExpandedRow = ({ errors, t }) => {
  if (!errors || errors.length === 0) return null;

  return (
    <div style={{ color: '#d32f2f', fontSize: 13, padding: '8px 16px' }}>
      {errors.map((errorKey) => (
        <div key={errorKey}>{t(errorKey)}</div>
      ))}
    </div>
  );
};

ExpandedRow.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string).isRequired, // Array of strings
  t: PropTypes.func.isRequired, // Translation function
};

export default ExpandedRow;
